import React, { Component } from "react";
import { Parallax } from "react-skrollr";
import { multiLanguage } from "../../hoc";

const lagunaImgBackground =
  "https://lagunaproperty.com/images/LAGUNA_IMAGE_BACKGROUND.jpg";
const lagunaImgBuilding =
  "https://lagunaproperty.com/images/LAGUNA_IMAGE_BUILDING.jpg";

@multiLanguage()
class section1 extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="section1">
        <div className="parallax-container">
          <Parallax
            data={{
              "data-0-start": "transform: translateY(0px) scale(1);",
              "data-top-bottom": "transform: translateY(10px) scale(1.3);",
            }}
          >
            <div
              className="bg-background"
              style={{
                backgroundImage: `url(${lagunaImgBackground})`,
              }}
            />
          </Parallax>
          <Parallax
            data={{
              "data-0-start": "transform: translateY(0px);",
              "data-top-bottom": "transform: translateY(100px);",
            }}
          >
            <img className="bg-building" src={lagunaImgBuilding} alt="img-bg" />
          </Parallax>
        </div>
        <div className="section-name">{t("The Santuary Club")}</div>
      </div>
    );
  }
}

export default section1;



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Section1.js